var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.439,
    height: 15.279,
    viewBox: "0 0 23.439 15.279",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-group",
    "data-name": "Icon material-group",
    d: "M16.8,13.62a3.06,3.06,0,1,0-3.06-3.06A3.047,3.047,0,0,0,16.8,13.62Zm-8.16,0a3.06,3.06,0,1,0-3.06-3.06A3.047,3.047,0,0,0,8.64,13.62Zm0,2.04c-2.376,0-7.14,1.193-7.14,3.57v2.55H15.779v-2.55C15.779,16.853,11.016,15.66,8.64,15.66Zm8.16,0c-.3,0-.632.02-.989.051a4.3,4.3,0,0,1,2.009,3.519v2.55h6.12v-2.55C23.939,16.853,19.176,15.66,16.8,15.66Z",
    transform: "translate(-1 -7)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.c05bf6bf61076f9e55f5f6d5be4e80b1.svg";
export { ForwardRef as ReactComponent };